import React from 'react';
import { Globe, Linkedin } from 'lucide-react';
interface CoachCardProps {
  name: string;
  role: string;
  image: string;
  bio: string;
  specialties?: string[];
  linkedin?: string;
  website?: string;
}
export const CoachCard = ({
  name,
  role,
  image,
  bio,
  specialties,
  linkedin,
  website
}: CoachCardProps) => {
  return <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-6 flex flex-col items-center text-center transition-all duration-300 hover:bg-white/10" data-id="element-337" data-mp="1xll7ln2e1ae9">
      <img src={image} alt={name} className="w-48 h-48 rounded-full object-cover mb-6 border-2 border-white/20" data-id="element-338" data-mp="26g9e1gjp8y4n" />
      <div className="flex items-center gap-3 mb-2" data-id="element-339" data-mp="2lanwnfzcq5is">
        <h3 className="font-outfit text-2xl font-bold text-white" data-id="element-340" data-mp="2gddwp6ec6bgp">{name}</h3>
        {(linkedin || website) && <div className="flex gap-2" data-id="element-341" data-mp="qzinjw5hx0w2">
            {linkedin && <a href={linkedin} target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors" aria-label={`${name} on LinkedIn`} data-id="element-342" data-mp="m05yr5v2djqu">
                <Linkedin size={20} data-id="element-343" data-mp="kq7y88f2884v" />
              </a>}
            {website && <a href={website} target="_blank" rel="noopener noreferrer" className="text-white/60 hover:text-white transition-colors" aria-label={`${name}'s website`} data-id="element-344" data-mp="ppubuiysvqe7">
                <Globe size={20} data-id="element-345" data-mp="14f8k1nqn41s0" />
              </a>}
          </div>}
      </div>
      <p className="text-white/60 font-medium mb-4" data-id="element-346" data-mp="18jgcnw07y1vi">{role}</p>
      <p className="text-white/80 mb-4 font-manrope" data-id="element-347" data-mp="1dhrnoa292ifb">{bio}</p>
      {specialties && <div className="flex flex-wrap gap-2 justify-center" data-id="element-348" data-mp="3a9jiptniexjv">
          {specialties.map(specialty => <span key={specialty} className="bg-white/5 border border-white/10 px-3 py-1 rounded-full text-sm text-white/80" data-id="element-349" data-mp="3f8cxrqig2wm5">
              {specialty}
            </span>)}
        </div>}
    </div>;
};